export interface CapabilityGatedItem {
  moduleKey?: string;
}

export function canAccessNavItem(item: CapabilityGatedItem, capabilityKeys: string[]): boolean {
  return !item.moduleKey || capabilityKeys.includes(item.moduleKey);
}

export function filterNavItemsByCapabilities<T extends CapabilityGatedItem>(
  items: T[],
  capabilityKeys: string[]
): T[] {
  return items.filter((item) => canAccessNavItem(item, capabilityKeys));
}
